import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { map } from "rxjs/operators";
import { mensajesModalRnec } from "src/app/core/enums/rnec/mensaje-modal-rnec.enum";
import { IVI, IVI_MESSAGES_USUARIO } from "src/app/core/enums/rnec/rnec.enum";
import { DocumentosDigitalesManager } from "src/app/core/gestor-contenido-documentos/validarDocumento";
import { IDocumentoNoExigible } from "src/app/core/models/documentosObligatorios/idocumentosObligatorios";
import { GeneralResponse } from "src/app/core/models/general-response/general-response";
import { DetalleAfiliadoHijo } from "src/app/core/models/rnec/detalleAfiliadoHijo";
import { IdentidadPersonaDto } from "src/app/core/models/rnec/identidad-persona.dto";
import { RnecResponseDto } from "src/app/core/models/rnec/rnec-response.dto";
import { ModalVariadoService } from "src/app/core/services/modal-variado/modal-variado.service";
import { ObligatoriedadDocumentosService } from "src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service";
import { RnecService } from "src/app/core/services/rnec/rnec.service";
import { ValidacionesFormularioService } from "./validacionesFormulario.service";



@Injectable({
  providedIn: 'root'
})
export class ConsultaRnecService {
  private contIntento = 0;
  private tipoPersonaAnterior: string;
  private intentosPermitidos = 3;
  private estadoRnec: any;
  public botonContinuar: boolean = false;
  constructor(
    private validacionesFormularioService: ValidacionesFormularioService,
    private _ModalVariadoService: ModalVariadoService,
    private _RnecService: RnecService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public _ObligatoriedadDocumentosService: ObligatoriedadDocumentosService
  ) {
  }

  public realizarConsulta(
    tipoPersona: string,
    identidadBeneficiario: any,
    personaControl: any,
    form: any,
    index?: number,
  ): void {
    this.contIntento = tipoPersona !== this.tipoPersonaAnterior ? 0 : this.contIntento;

    const acciones = {
      documentoInvalido: () => this.mostrarError(tipoPersona, personaControl),
      ejecutarValidacion: () => {
        this.ejecutarValidacion(tipoPersona, identidadBeneficiario, personaControl, form);
        this.contIntento++;
      },
      maxIntentos: () => {
        this.mostrarError(tipoPersona, personaControl);
        this.contIntento = 0;
      }
    };
    if (this.esDocumentoValido(personaControl)) {
      if (this.contIntento < this.intentosPermitidos) {
        acciones.ejecutarValidacion();
      } else {
        acciones.maxIntentos();
      }
    } else {
      acciones.documentoInvalido();
    }
    this.tipoPersonaAnterior = tipoPersona;
  }

  private ejecutarValidacion(tipoPersona: string, identidadBeneficiario: any, personaControl: any, form: any): void {
    const estrategiaValidacion: Record<string, () => void> = {
      beneficiario: () => this.validarBeneficiario(personaControl, identidadBeneficiario, form),
      default: () => this.consultaRnec(tipoPersona, identidadBeneficiario, personaControl),
    };

    (estrategiaValidacion[tipoPersona] || estrategiaValidacion.default)();
  }

  private validarBeneficiario(personaControl: any, identidadBeneficiario: any, form: any): void {
    if (personaControl.getRawValue().parentescoPerCarg["name"] !== "Hijo") {
      this.consultaRnec("beneficiario", identidadBeneficiario, personaControl);
      return;
    }

    const trabajadorValues = form;

    const detalleAfiliadoHijo: DetalleAfiliadoHijo = {
      identidadPersonaHijo: IdentidadPersonaDto.objBeneficiarioARnc(personaControl.getRawValue()),
      identidadPersonaAfiliado: IdentidadPersonaDto.objTrabajadorARnc(trabajadorValues)
    };
    this.validarHijo(detalleAfiliadoHijo, personaControl);
  }

  private mostrarError(tipoPersona: string, personaControl: any): void {
    const handlers: Record<string, (control: any, tipo: string) => void> = {
      trabajador: this.mostrarErrorTitular.bind(this),
      conyuge: this.mostrarErrorConyuge.bind(this),
      beneficiario: this.mostrarErrorBeneficiario.bind(this)
    };

    handlers[tipoPersona]?.(personaControl, tipoPersona);
  }

  private mostrarErrorTitular(personaControl: any, tipoPersona: any): void {
    try {
      this.validacionesFormularioService.validarTrabajador(personaControl);
      this.validarDocumentos(personaControl, tipoPersona);
      this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
      this.botonContinuar = true;
      personaControl.get('EsValido').setValue(false);
    } catch (error) {
      console.error("❌ Error en mostrarErrorTitular:", error);
    }
  }

  private mostrarErrorConyuge(personaControl: any, tipoPersona: any): void {
    this.validacionesFormularioService.validarConyuge(personaControl);
    this.validarDocumentos(personaControl, tipoPersona);
    this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
    this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(true);

    const btnConsultarConyuge = document.getElementById('btnConsultarConyuge');
    if (btnConsultarConyuge) {
      btnConsultarConyuge.style.display = 'none';
    } else {
      console.log('El botón con id "btnConsultarConyuge" no se encontró.');
    }
  }


  private mostrarErrorBeneficiario(personaControl: any, tipoPersona: any): void {
    this.validacionesFormularioService.validarParentescoBeneficiario(personaControl);
    this.validarDocumentos(personaControl, tipoPersona);
    this._ModalVariadoService.modalError(mensajesModalRnec.datosParaDoc);
    personaControl.get('EsValido').setValue(true);
    this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true);
  }

  private consultaRnec(tipoPersona: string, identidadBeneficiario: any, form: FormGroup) {
    this._ModalVariadoService.ModalProceso('Procesando...');

    return this._RnecService.consultar(identidadBeneficiario).subscribe(
      (rnecResponse: GeneralResponse<RnecResponseDto>) => {
        this.estadoRnec = rnecResponse.body;

        if (!this._RnecService.esIdentidadValidadaExitosamente(this.estadoRnec.ivi)) {
          setTimeout(() => this.finalizarProceso(), 100);
          return;
        }

        this.handlePersonaValidation(tipoPersona, form);

        const acciones: Record<string, () => void> = {
          trabajador: () => {
            form.patchValue({ base64Valid: this.estadoRnec.validacion });
          },
          conyuge: () => this.actualizarGrupoConyugeBase64(form),
          beneficiario: () => this.actualizarGrupoBeneficiarioBase64(form)
        };

        acciones[tipoPersona]?.();

        setTimeout(() => this.finalizarProceso(), 100);
      }
    );
  }

  private validarHijo(detalleAfiliadoHijo: DetalleAfiliadoHijo, form: FormGroup): void {
    this._ModalVariadoService.ModalProceso('Procesando desde el servicio...');

    this._RnecService.validarHijo(detalleAfiliadoHijo).subscribe(
      (response: GeneralResponse<any>) => {
        this.estadoRnec = response.body;

        if (response.body.validacion) {
          this.realizarAccionesValidacionExitosa(form);
        }

        this.finalizarProcesoConRetraso();
      }
    );
  }

  private realizarAccionesValidacionExitosa(form: FormGroup): void {
    this.handlePersonaValidation("beneficiario", form);
    this.procesarValidacionHijoExitosa(form);
  }

  private finalizarProcesoConRetraso(): void {
    setTimeout(() => this.finalizarProceso(), 100);
  }

  private handlePersonaValidation(tipoPersona: string, form: FormGroup) {
    const validadores = {
      trabajador: () => this.validacionesFormularioService.validarTrabajador(form),
      conyuge: () => this.validacionesFormularioService.validarConyuge(form),
      beneficiario: () => this.validacionesFormularioService.validarParentescoBeneficiario(form)
    };
    validadores[tipoPersona]();
  }

  private actualizarGrupoConyugeBase64(form: FormGroup) {
    document.getElementById('btnConsultarConyuge')!.style.display = 'none';

    form.patchValue({
      base64Valid: this.estadoRnec.validacion,
    });
    this.validarDocumentos(form, "conyuge");
    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosConyuge.filter(documento =>
      documento.idForm !== "documentoIdentidadConyuge"
    );
    this._ObligatoriedadDocumentosService.documentosConyuge = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosConyugeSubject.next(this._ObligatoriedadDocumentosService.documentosConyuge);
  }

  private actualizarGrupoBeneficiarioBase64(form: FormGroup) {
    form.get('EsValido').setValue(true);
    if (!form.contains('base64Valid')) {
      form.addControl('base64Valid', new FormControl(null));
    }

    form.patchValue({ base64Valid: this.estadoRnec.validacion });

    this.validacionesFormularioService.validarParentescoBeneficiario(form);
    this.validarDocumentos(form, 'beneficiario');
    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosBeneficiario.filter(documento =>
      documento.idForm !== "idBeneficiario"
    );
    this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosBeneficiarioSubject.next(this._ObligatoriedadDocumentosService.documentosBeneficiario);
    this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true)
  }

  private procesarValidacionHijoExitosa(form: FormGroup): void {
    form.get('EsValido')?.setValue(true);

    if (!form.contains('base64Valid')) {
      form.addControl('base64Valid', new FormControl(null));
    }

    form.patchValue({ base64Valid: this.estadoRnec.validacion });
    const documentosActualizados = this._ObligatoriedadDocumentosService.documentosBeneficiario.filter(documento =>
      documento.idForm !== "docIdeTrabajador" &&
      documento.idForm !== "idBeneficiario" &&
      documento.idForm !== "regBeneficiario"
    );

    this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosActualizados;
    this._ObligatoriedadDocumentosService.documentosBeneficiarioSubject.next(this._ObligatoriedadDocumentosService.documentosBeneficiario);
    this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true)
  }

  public async validarDocumentos(personaControl: any, tipoPersona: any, form?: FormGroup): Promise<void> {
    const titular = personaControl.getRawValue();

    this.configurarDocumentosPorTipoPersona(tipoPersona);

    this.obtenerDocumentosExistentes("", titular, tipoPersona);
  }

  private configurarDocumentosPorTipoPersona(tipoPersona: string): void {
    const documentosMap: { [key: string]: any } = {
      "beneficiario": this._ObligatoriedadDocumentosService.documentosBeneficiario,
      "trabajador": this._ObligatoriedadDocumentosService.documentosTitular,
      "conyuge": this._ObligatoriedadDocumentosService.documentosConyuge
    };

    const documentos = documentosMap[tipoPersona];

    if (documentos) {
      DocumentosDigitalesManager.setDocumentosSolicitud(documentos);
    }
  }

  private obtenerDocumentosExistentes(trabajadorValues: any, beneficiario: any, tipoPersona: string) {
    this._ObligatoriedadDocumentosService
      .getDocumentosDigitalesExistentesDepropietario(
        trabajadorValues.NumIdTrabajador,
        beneficiario.NumIdConyuge
      )
      .pipe(map((response: GeneralResponse<IDocumentoNoExigible[]>) => response))
      .subscribe((response: GeneralResponse<IDocumentoNoExigible[]>) => {
        this.procesarRespuestaDeDocumentos(response.body, trabajadorValues, beneficiario, tipoPersona);
      });
  }

  private procesarRespuestaDeDocumentos(
    responseBody: IDocumentoNoExigible[],
    trabajadorValues: any,
    beneficiario: any,
    tipoPersona: string
  ) {
    const { documentosObligatorios, documentosEliminados } = DocumentosDigitalesManager.retirarDocumentosNoExigibles(
      responseBody,
      trabajadorValues.TipoIdTrabajador,
      trabajadorValues.NumIdTrabajador,
      beneficiario.TipoIdConyuge,
      beneficiario.NumIdConyuge
    );

    this.actualizarDataJsonConDocumentos(documentosObligatorios, tipoPersona);
  }

  private actualizarDataJsonConDocumentos(documentosObligatorios: IDocumentoNoExigible[], tipoPersona: string) {
    if (tipoPersona == "trabajador") {
      this._ObligatoriedadDocumentosService.documentosTitular = documentosObligatorios;
    } else {
      this._ObligatoriedadDocumentosService.documentosConyuge = documentosObligatorios;
      this._ObligatoriedadDocumentosService.documentosConyugeListosSubject.next(true);
      this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true);
    }
    if(tipoPersona == "beneficiario"){
      this._ObligatoriedadDocumentosService.documentosBeneficiario = documentosObligatorios;
      this._ObligatoriedadDocumentosService.documentosBeneficiarioListosSubject.next(true);
    }
  }

  public modalOpen(): void {
    const modalMap: { [key: string]: Function } = {
      [IVI.IVE]: () => {
        this._ModalVariadoService.modalConfirmacion(IVI_MESSAGES_USUARIO[this.estadoRnec.ivi]);
      },
      default: () => {
        this._ModalVariadoService.modalError(IVI_MESSAGES_USUARIO[this.estadoRnec.ivi]);
      }
    };

    (modalMap[this.estadoRnec.ivi] || modalMap.default)();
  }

  public finalizarProceso() {
    this.dialog.closeAll();
    this.modalOpen();
  }

  private esDocumentoValido(tipoIdentificacion: FormGroup): boolean {
    const valores = tipoIdentificacion.getRawValue();
    const tipoDocumento = valores.TipoIdTrabajador || valores.TipoIdConyuge || valores.tipoDocumento;

    return this._RnecService.esTipoDocumentoParaConsultar(tipoDocumento);
  }
}
